import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { de } from '../i18n/de';
import { BrandLogo } from './BrandLogo';
import { SiteFooter } from './SiteFooter';

/** Karte für Anmeldung, Registrierung und Passwort: oben Logo und Name (zurück zur Startseite) mit „Beta“, darunter die Seite; unten die Fußzeile. */
export function AuthFrame({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="auth-page">
      <main className="auth-card col">
        <Link to="/" className="auth-brand" title={de.auth.toLanding} data-testid="auth-brand">
          <BrandLogo className="brand-logo" />
          <span className="brand-name">{de.app.name}</span>
          <span className="beta-pill">{de.landing.beta}</span>
        </Link>
        <h1 className="auth-title">{title}</h1>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
